import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import { IDate, IPayrollPayCalendar, EExceptionType, IUserFilter } from "../../../models"
import DateRangeSelect from "../../../components/common/DateRangeSelect"
import * as reportAction from "../../../actions/ReportAction"
import AccountStore from "../../../stores/AccountStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import moment from "moment"
import * as timecardHelper from "../../../helpers/timecardHelper"
import * as payrollHelper from "../../../helpers/payrollHelper"

interface IProps {
	referenceDate: IDate
	selectedPayrollPayCalendar: IPayrollPayCalendar
	userFilter: IUserFilter
	handleClose(): void

	// job->Timecard report
	jobId: string

	// Timecard page report
	filterByDefaultHierarchy: boolean
	filterDirectReportsOnly: boolean
	filterByPunchHierarchy: boolean
	filterByException: boolean
	filterExceptions: EExceptionType[]
}
interface IState {
	startDate: IDate
	endDate: IDate
	isValid: boolean
}

export default class PunchQuestionResponseReportDialog extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		const timecardDates = timecardHelper.getTimecardDateByPayrollPayCalendar(props.referenceDate, props.selectedPayrollPayCalendar)
		this.state = {
			startDate: moment(timecardDates.StartDate).utc(true).format(),
			endDate: moment(timecardDates.EndDate).utc(true).format(),
			isValid: true
		}
		autobind(this)
	}

	handleDownload() {
		this.props.handleClose()
		const payGroupIds = payrollHelper.getPayGroupIdsByPayrollPayCalendar(this.props.selectedPayrollPayCalendar)
		this.props.jobId ?
			reportAction.downloadJobTimecardPunchQuestionResponseReport(
				AccountStore.getCurrentAccount().Id,
				this.props.jobId,
				this.state.startDate as string,
				this.state.endDate as string,
				payGroupIds,
				this.props.userFilter
			) :
			reportAction.downloadPunchQuestionResponseReport(
				AccountStore.getCurrentAccount().Id,
				this.state.startDate as string,
				this.state.endDate as string,
				HierarchySettingsStore.getGlobalLevelItemFilterId(),
				payGroupIds,
				this.props.userFilter,
				this.props.filterByDefaultHierarchy,
				this.props.filterDirectReportsOnly,
				this.props.filterByPunchHierarchy,
				this.props.filterByException,
				this.props.filterExceptions
			)
	}

	render() {
		return (
			<Dialog
				open
				title={strings.Punch_Question_Response_Report}
				actions={[
					<FlatButton data-intercom-target={"Timecards-Reports-Btn-ClosePunchQuestionResponseReportDialog"} key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
					<FlatButton data-intercom-target={"Timecards-Reports-Btn-DownloadPunchQuestionResponseReport"} key="download" label={strings.Download} disabled={!this.state.isValid} primary onTouchTap={this.handleDownload} />
				]}
			>
				<DateRangeSelect
					startDate={this.state.startDate}
					endDate={this.state.endDate}
					handleChange={(startDate, endDate, isValid) => this.setState({ startDate, endDate, isValid })}
					sameDatesAllowed
				/>
			</Dialog>
		)
	}
}